import { PageHeader } from "../../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Health from "./governance/Health";
import Backups from "./governance/Backups";
import Audit from "./governance/Audit";
import Trash from "./governance/Trash";
import Notify from "./governance/Notify";

export default function Governance() {
  return (
    <div className="space-y-6" data-testid="governance-page">
      <PageHeader eyebrow="Sistem" title="Yedek & Denetim" subtitle="Veri güvenliği: otomatik yedekler, kim ne yaptı kaydı, silinenlerin geri alınması, anlık bildirim kanalları ve sistem sağlığı." />
      <Tabs defaultValue="health" urlTab>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="health" data-testid="gtab-health">Sistem Sağlığı</TabsTrigger>
          <TabsTrigger value="backups" data-testid="gtab-backups">Yedekler</TabsTrigger>
          <TabsTrigger value="audit" data-testid="gtab-audit">Denetim Kaydı</TabsTrigger>
          <TabsTrigger value="trash" data-testid="gtab-trash">Çöp Kutusu</TabsTrigger>
          <TabsTrigger value="notify" data-testid="gtab-notify">Bildirim Kanalları</TabsTrigger>
        </TabsList>
        <TabsContent value="health" className="mt-4"><Health /></TabsContent>
        <TabsContent value="backups" className="mt-4"><Backups /></TabsContent>
        <TabsContent value="audit" className="mt-4"><Audit /></TabsContent>
        <TabsContent value="trash" className="mt-4"><Trash /></TabsContent>
        <TabsContent value="notify" className="mt-4"><Notify /></TabsContent>
      </Tabs>
    </div>
  );
}
